import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { concatMap } from 'rxjs';

import { GiveawayService } from '../../core/services/data/giveaway.service';
import { UserService } from '../../core/services/data/user.service';

import { IUser } from '../../types/datatypes';
import { IGiveawayWithDownloadURL } from '../../types/local';
import { GiveawaysWithDownloadURLReponse } from '../../types/responses';

@Component({
	selector: 'app-download-callout',
	templateUrl: './download-callout.component.html',
	styleUrls: ['./download-callout.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DownloadCalloutComponent implements OnDestroy, OnInit {
	public callouts: IGiveawayWithDownloadURL[] = [];

	public subscription;

	constructor(
		private giveawaysService: GiveawayService,
		private userService: UserService,
	) {}

	ngOnInit() {
		this.initialize();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	get currentCallout() {
		return this.callouts[0];
	}

	get siteAdvertName() {
		return this.currentCallout?.featureId._siteAdvert.name;
	}

	initialize() {
		this.subscription = this.userService.author$
			.pipe(concatMap((author: IUser) => this.giveawaysService.getCallouts(author._id)))
			.subscribe((result: GiveawaysWithDownloadURLReponse) => {
				if (result.success) {
					this.callouts = result.giveaways as IGiveawayWithDownloadURL[];
				}
			});
	}

	clearNotification(giveawayId: string) {
		this.giveawaysService.clearNotification(giveawayId)
			.subscribe((result: GiveawaysWithDownloadURLReponse) => {
				if (result.success) {
					this.callouts.shift();
				}
			});
	}
}
